"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";

export function AdvSearchNoResults({}) {
  return (
    <Block className={"adv-search-no-results-container"} tag={"div"}>
      <Block className={"adv-search-no-results-text"} tag={"div"}>
        {"We could not find any locations matching your search in this area."}
        <br />
      </Block>
    </Block>
  );
}
